/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import { type WidgetDateRangeCustom, WidgetDateRangeCustomFromJSONTyped, WidgetDateRangeCustomToJSON, WidgetDateRangeCustomToJSONTyped } from './WidgetDateRangeCustom';
import { type WidgetDateRangePreset, WidgetDateRangePresetFromJSONTyped, WidgetDateRangePresetToJSON, WidgetDateRangePresetToJSONTyped } from './WidgetDateRangePreset';
/**
 * 
 * @export
 * @interface WidgetDateRangeRequest
 */
export interface WidgetDateRangeRequest {
    /**
     * 
     * @type {string}
     * @memberof WidgetDateRangeRequest
     */
    mode: string;
}

/**
 * Check if a given object implements the WidgetDateRangeRequest interface.
 */
export function instanceOfWidgetDateRangeRequest(value: object): value is WidgetDateRangeRequest {
    if (!('mode' in value) || value['mode'] === undefined) return false;
    return true;
}

export function WidgetDateRangeRequestFromJSON(json: any): WidgetDateRangeRequest {
    return WidgetDateRangeRequestFromJSONTyped(json, false);
}

export function WidgetDateRangeRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): WidgetDateRangeRequest {
    if (json == null) {
        return json;
    }
    if (!ignoreDiscriminator) {
        if (json['mode'] === 'WidgetDateRangeCustom') {
            return WidgetDateRangeCustomFromJSONTyped(json, ignoreDiscriminator);
        }
        if (json['mode'] === 'WidgetDateRangePreset') {
            return WidgetDateRangePresetFromJSONTyped(json, ignoreDiscriminator);
        }
    }
    return {
        
        'mode': json['mode'],
    };
}

export function WidgetDateRangeRequestToJSON(json: any): WidgetDateRangeRequest {
    return WidgetDateRangeRequestToJSONTyped(json, false);
}

export function WidgetDateRangeRequestToJSONTyped(value?: WidgetDateRangeRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    if (!ignoreDiscriminator) {
        switch (value['mode']) {
            case 'WidgetDateRangeCustom':
                return WidgetDateRangeCustomToJSONTyped(value as WidgetDateRangeCustom, ignoreDiscriminator);
            case 'WidgetDateRangePreset':
                return WidgetDateRangePresetToJSONTyped(value as WidgetDateRangePreset, ignoreDiscriminator);
            default:
                return value;
        }
    }

    return {
        
        'mode': value['mode'],
    };
}

